import { Box, Grid } from "@mui/material";
import {
	EnhancedButtonPrimeReact,
	EnhancedButtonPrimeReactSeverity,
	EnhancedDropDownRHFWithLabel,
	LabelPosition,
	RHookFormDatePicker,
} from "@websential/cosmic-v20";
import React, { useEffect, useState } from "react";

interface IPayrollReportHeader {
	setStateRunGetListAPICall: (value: boolean) => void
	departmentsDDL: any;
	employeeDDLItems: any;
	teamsDDL: any;
	expenseCategoryDDLItems: any;
	provinceOfEmploymentDDLItems: any;
	payPeriodDDLItems: any;
	payPeriodEndDateDDLItems: any;
	onPeriodEndDateSelectionChangeHandler: (value: string) => void
	taxYear: number;
}

export const PayrollReportHeader: React.FC<
	IPayrollReportHeader
> = ({
	setStateRunGetListAPICall, departmentsDDL, employeeDDLItems, teamsDDL, expenseCategoryDDLItems,
	provinceOfEmploymentDDLItems, payPeriodDDLItems, onPeriodEndDateSelectionChangeHandler, payPeriodEndDateDDLItems,
	taxYear
}) => {

		const onPayPeriodSelectionChangeHandler = (e: any) => {
			// formMethods.setValue('endDate', undefined)
			onPeriodEndDateSelectionChangeHandler(e.value);
			setStateRunGetListAPICall(false)
		}

		return (
			<>
				<Grid
					container
					size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}
					sx={{
						background: "#fff",
						border: "1px solid #e5e7eb",
						borderBottom: 0,
						borderRadius: "2px 2px 0 0",
						padding: "31px 20px 1rem 20px",
						marginBottom: "0px!important",
					}} columnSpacing={2}>
					<Grid
						size={{ xs: 12, sm: 12, md: 2, lg: 2, xl: 2 }}
						// sx={{ mt: "12px" }}
						sx={{
							color: "rgba(0, 0, 0, 0.6)", fontSize: "0.875rem",
							"& .MuiGrid-root": {
							},
						}}>
						<EnhancedDropDownRHFWithLabel
							selectName={"groupBy"}
							items={[

								{
									label: "Pay Period",
									value: 400,
								},
								{
									label: "Calendar Month",
									value: 100,
								},
								{
									label: "Employees",
									value: 300,
								},
								{
									label: "Team",
									value: 500,
								},
								{
									label: "Department",
									value: 200,
								},
							]}
							label={"Group By"}
							testId={"group-by"}
							// selectedItem={"all"}
							selectedItem={400}
							// onSelectionChangeHandler={onEmployeeStatusSelectionChangeHandler}
							onSelectionChangeHandler={() => setStateRunGetListAPICall(true)}
						/>
						<EnhancedDropDownRHFWithLabel
							selectName={"reportDate"}
							items={[

								{
									label: "Payment Date",
									value: 200,
								},
								{
									label: "End Date",
									value: 100,
								},

							]}
							label={"Report Date"}
							testId={"report-date"}
							// selectedItem={"all"}
							selectedItem={200}
						// onSelectionChangeHandler={onEmployeeStatusSelectionChangeHandler}
						/>
						<EnhancedDropDownRHFWithLabel
							selectName={"employee"}
							items={employeeDDLItems ?? []}
							selectedItem={"all"}
							label={"Employee"}
							testId={"employee-ddl"}
							onSelectionChangeHandler={() => setStateRunGetListAPICall(false)}
						/>

						<EnhancedButtonPrimeReact
							label="Apply Filter"
							raised
							type="submit"
							severity={EnhancedButtonPrimeReactSeverity.Secondary}
						// onClickHandler={() => setStateRunGetListAPICall(true)}
						/>

					</Grid>

					<Grid
						size={{ xs: 12, sm: 12, md: 2, lg: 2, xl: 2 }}
						sx={{
							"& .calenderWrapper ": {
								marginBottom: "0!important",
								minWidth: "178px!important"
								// fontSize: ".875rem" 
							}
						}}
					>
						<EnhancedDropDownRHFWithLabel
							selectName={"paymentStatus"}
							items={[
								{
									label: "All",
									value: "all",
								},
								{
									label: "Active",
									value: 100,
								},
								{
									label: "In-Active",
									value: 200,
								},
							]}
							label={"Payment Status"}
							testId={"payment-status"}
							selectedItem={"all"}
						// onSelectionChangeHandler={onEmployeeStatusSelectionChangeHandler}
						/>
						<EnhancedDropDownRHFWithLabel
							selectName={"payPeriod"}
							items={payPeriodDDLItems ?? []}
							selectedItem={"all"}
							label={"Pay Period"}
							testId={"pay-period-ddl"}
							// onSelectionChangeHandler={() => setStateRunGetListAPICall(false)}
							onSelectionChangeHandler={onPayPeriodSelectionChangeHandler}

						/>
						<RHookFormDatePicker
							name="startDate"
							testId="start-date"
							label="Date Range"
							format="M dd, yy"
							onDateSelectionChangeHandler={() => setStateRunGetListAPICall(false)}
							defaultValue={new Date(taxYear, 0, 1)}
						/>

					</Grid>
					<Grid size={{ xs: 12, sm: 12, md: 2, lg: 2, xl: 2 }}
						sx={{
							"& .calenderWrapper ": {
								marginTop: "19px!important",
								marginBottom: "0!important",
								minWidth: "178px!important"
								// fontSize: ".875rem" 
							}
						}}>
						<EnhancedDropDownRHFWithLabel
							selectName={"expenseCategory"}
							items={expenseCategoryDDLItems ?? []}
							selectedItem={"all"}
							label={"Expense Category"}
							testId={"expense-category-ddl"}
							onSelectionChangeHandler={() => setStateRunGetListAPICall(false)}
						/>
						<EnhancedDropDownRHFWithLabel
							selectName={"payPeriodEndDate"}
							items={payPeriodEndDateDDLItems ?? []}
							selectedItem={"all"}
							label={"End Date"}
							testId={"end-date-ddl"}
							onSelectionChangeHandler={() => setStateRunGetListAPICall(false)}
						/>
						<RHookFormDatePicker
							name="endDate"
							testId="end-date"
							format="M dd, yy"
							onDateSelectionChangeHandler={() => setStateRunGetListAPICall(false)} label={""}
							defaultValue={new Date(taxYear, 11, 31)}
						/>
					</Grid>
					<Grid
						size={{ xs: 12, sm: 12, md: 2, lg: 2, xl: 2 }}>
						<EnhancedDropDownRHFWithLabel
							selectName={"paymentMethod"}
							items={[
								{
									label: "All",
									value: "all",
								},
								{
									label: "Cheque",
									value: 100,
								},
								{
									label: "Direct Deposit",
									value: 200,
								},

							]}
							label={"Payment Method"}
							testId={"payment-method"}
							selectedItem={"all"}
						// onSelectionChangeHandler={onEmployeeStatusSelectionChangeHandler}
						/>
						<EnhancedDropDownRHFWithLabel
							selectName={"department"}
							items={departmentsDDL ?? []}
							selectedItem={"all"}
							label={"Department"}
							testId={"department-ddl"}
							onSelectionChangeHandler={() => setStateRunGetListAPICall(false)}
						/>
					</Grid>

					<Grid
						size={{ xs: 12, sm: 12, md: 2, lg: 2, xl: 2 }}>

						<EnhancedDropDownRHFWithLabel
							selectName={"provinceOfEmployment"}
							items={provinceOfEmploymentDDLItems ?? []}
							selectedItem={"all"}
							label={"Prov. of Employment"}
							testId={"province-of-employment-ddl"}
							onSelectionChangeHandler={() => setStateRunGetListAPICall(false)}
						/>
						<EnhancedDropDownRHFWithLabel
							selectName={"team"}
							items={teamsDDL ?? []}
							selectedItem={"all"}
							label={"Team"}
							testId={"team-ddl"}
							onSelectionChangeHandler={() => setStateRunGetListAPICall(false)}
						/>
					</Grid>
					<Grid
						size={{ xs: 12, sm: 12, md: 2, lg: 2, xl: 2 }}
						sx={{ color: "rgba(0, 0, 0, 0.6)", fontSize: "0.875rem", marginTop: "1.4rem", paddingLeft: "2rem" }}>


						<span style={{ height: "10px", width: "10px", background: "rgb(186, 216, 168)" }}>&nbsp;&nbsp;&nbsp;&nbsp;</span>&nbsp;
						<span>Cash Earnings</span>
						<br />
						<span style={{ height: "10px", width: "10px", background: "rgb(228, 243, 255)" }}>&nbsp;&nbsp;&nbsp;&nbsp;</span>&nbsp;
						<span>Non-Cash Earnings</span>
						<br />
						<span style={{ height: "10px", width: "10px", background: "rgb(255, 228, 248)" }}>&nbsp;&nbsp;&nbsp;&nbsp;</span>&nbsp;
						<span>Deductions</span>
						<br />
						<span style={{ height: "10px", width: "10px", background: "rgb(248, 255, 188)" }}>&nbsp;&nbsp;&nbsp;&nbsp;</span>&nbsp;
						<span>Non-Cash Dedutions</span>
						<br />
						<span style={{ height: "10px", width: "10px", background: "rgb(252, 219, 255)" }}>&nbsp;&nbsp;&nbsp;&nbsp;</span>&nbsp;
						<span>Reimbursement</span>

					</Grid>
				</Grid >

			</>
		);
	};
